/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */

function Voorbereiding() {
  return (
    <div>
      <div className="box light">
        <div className="row">
          <h1>Waarom Costa Rica?</h1>
          <p>
            We wilden al langere tijd een verre reis maken met het gezin, als de kinderen wat ouder zouden zijn maar nog thuis woonden. In de zomer van 2025 besloten we dat 2026
            het jaar zou worden. Daarom gingen we naar een vakantiebeurs in Gorinchem. Al snel zagen we een reis die ons allemaal erg aansprak: een rondreis door Costa Rica met een
            huurauto. Helaas was deze optie niet haalbaar, omdat Elise in die periode geen vrij kon krijgen. Omdat de website de rondreis tot in detail had uitgewerkt, ben ik zelf
            gaan uitzoeken wat het zou kosten als ik precies hetzelfde zelf zou boeken. Via de reisorganisatie bedroeg de totale reissom € 10.250 voor een gezin van vier personen
            (17 nachten, incl. 6 tours/excursies, excl. vliegtickets, benzine en bijna alle maaltijden). Toen ik dezelfde reis zelf boekte, kwam ik uit op € 6.967. Dat is een
            verschil van € 3.283 – een behoorlijk bedrag waar je veel leuke dingen mee kunt doen. Bovendien werden er in de reis keuzes gemaakt die wij zelf niet zouden maken,
            zoals een aantal zeer dure overnachtingen en een excursie naar een koffieplantage. Daarom besloten we alles zelf te regelen.
          </p>
          <p>
            We boekten zelf de vliegtickets, een huurauto, alle verblijven en een flink aantal tours en excursies. Dat is zeker goed te doen, maar het kost wel veel tijd. Die tijd
            gaat vooral zitten in het maken van keuzes, het zoeken naar beschikbare accommodaties op de juiste locatie tegen de juiste prijs, en de communicatie met de eigenaren –
            die niet altijd snel reageren of niet altijd een duidelijk antwoord geven. Ook het reserveren van vliegtickets, huurauto’s en tours via verschillende websites en apps
            neemt veel tijd in beslag. Uiteindelijk betaalden we voor de reis van 21 nachten € 9.035, excl. vliegtickets maar incl. autohuur, 13 tours/excursies en alle uitgaven
            ter plekke, zoals benzine, tol, alle maaltijden, supermarktaankopen en zelfs souvenirs. Als we dat vergelijken met de georganiseerde reis, moeten we daar in ieder geval
            nog de kosten voor benzine (€ 150), maaltijden (€ 750) en supermarktaankopen (€ 200) bij optellen. Voor 21 nachten zouden we dan uitkomen op € 14.020.
          </p>
          <p>
            Conclusie: als georganiseerde reis zou deze reis zeker € 4.985 meer hebben gekost. Daarnaast hadden we dan tours en excursies gedaan waar we liever andere voor in de
            plaats hadden gedaan, en hadden we ter plekke nog extra uitgaven gemaakt. Dat betekent dat je met het zelf regelen van een dergelijke reis heel veel geld kunt besparen
            – in ons geval zeker € 5.000.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Voorbereiding;
